import { render, staticRenderFns } from "./CompItemManageList.vue?vue&type=template&id=2c1a3976&scoped=true"
import script from "./CompItemManageList.vue?vue&type=script&lang=js"
export * from "./CompItemManageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a3976",
  null
  
)

export default component.exports